var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormLicenseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5332 1.46663V1.7333C4.5332 2.26663 4.9332 2.66663 5.46654 2.66663C5.86654 2.66663 6.1332 2.39997 6.26654 1.99997L6.5332 1.3333L13.9999 4.39997L8.79987 7.99997C8.26654 8.39997 8.26654 8.9333 8.39987 9.46663L9.59987 12.2666L7.86654 17.4666C7.59987 18.1333 8.1332 18.6666 8.66654 18.6666C9.06654 18.6666 9.3332 18.5333 9.46654 18L11.3332 12.6666L11.4665 13.0666V17.7333C11.4665 17.7333 11.4665 18.6666 12.3999 18.6666C13.3332 18.6666 13.3332 17.7333 13.3332 17.7333V13.3333C13.3332 13.0666 13.3332 12.9333 13.1999 12.6666L11.3332 8.1333L14.9332 5.59997C15.1999 5.3333 15.4665 5.19997 15.4665 4.79997C15.4665 4.39997 15.1999 4.1333 14.9332 3.99997L5.3332 0.133301C5.21587 0.133301 5.17587 0.157301 5.06654 0.266634L4.5332 1.46663ZM7.3332 3.99997C6.26654 3.99997 5.3332 4.9333 5.3332 5.99997C5.3332 7.06663 6.26654 7.99997 7.3332 7.99997C8.39987 7.99997 9.3332 7.06663 9.3332 5.99997C9.3332 4.9333 8.39987 3.99997 7.3332 3.99997Z",
    fill: "#242B42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormLicenseIcon);
export default __webpack_public_path__ + "static/media/formLicenseIcon.2f94d5261ab97bef4d296ef07fa73e91.svg";
export { ForwardRef as ReactComponent };